export const errorRepresentation = (metadata) => {
    return {
        didResolutionMetadata: metadata,
        didDocument: null,
        didDocumentMetadata: {},
    };
};
export const withResolutionError = (f) => {
    return f().catch((e) => errorRepresentation({
        error: 'invalidDid',
        message: e.toString(),
    }));
};
